export interface HHMapReport {
    patient: HHMapInfo | null;
    attentions: AttentionMapInfo[];
}

export interface HHMapInfo {
    latitude: number;
    longitude: number;
    description: string;
}

export interface AttentionMapInfo {
    professionalattentionlog:number;
    latitude: number;
    longitude: number;
    description: string;
    statedhour: Date;
    validated: boolean;
    isarrival: boolean;
}

export const defaultHHMapReport: HHMapReport = {
    patient: null,
    attentions: []
};
